
const PhoneIcon = ({ width = 13, height = 13, fill = 'currentColor', className = '' }) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.292 0.655464L1.24864 1.69883C0.394596 2.55287 0.159905 3.84711 0.659699 4.94665C2.10915 8.13546 4.66484 10.6911 7.85364 12.1406C8.95319 12.6404 10.2474 12.4057 11.1015 11.5517L12.1448 10.5083C12.4849 10.1682 12.4849 9.61678 12.1448 9.27669L10.7413 7.87313C10.4762 7.60807 10.0713 7.54236 9.736 7.70999L8.95707 8.09946C8.28651 8.43474 7.47665 8.30331 6.94653 7.7732L5.0271 5.85376C4.49698 5.32365 4.36556 4.51378 4.70083 3.84323L5.0903 3.06429C5.25794 2.72902 5.19223 2.32408 4.92717 2.05902L3.52361 0.655464C3.18351 0.315366 2.6321 0.315366 2.292 0.655464Z" stroke="#0C0C0C" strokeWidth="0.8" strokeLinejoin="round" />
    </svg>
  )
}

export default PhoneIcon
